export default {
    loadError:   'Не удалось загрузить данные по статистике',
    noData:      'Данных по статистике пока нет',
    targetLeads: 'Целевые лиды',
    tour:        {
        content: 'Контролируйте баланс оставшихся лидов и поступление заявок',
        title:   'Следите за лидами',
    },
};
